import { defineStore } from 'pinia'
import { ref } from 'vue'

// The campaign pages' right panel, shown or hidden from the header.
export const useSidePanelStore = defineStore('campaign-side-panel', () => {
  const open = ref(true)
  return { open }
})
